import { ActionButton, Button, Flex, Heading, TextField, View } from '@adobe/react-spectrum';
import styles from '../../../../styles.module.scss';
import { useState } from 'react';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import { useMainContainerProvider } from '../../../../mainContainerProvider';
import useFetchWithAuth from '../../../../CommonHooks/useFetchWithAuth';
import { errorToast } from '../../../../CommonComponent/toast';
import Loader from '../../../../CommonComponent/Loader';
import { paymentDataForStudent } from '../constant';
import { StudentPaymentData } from '../../types';

const SearchStudent = ({ setStudentData }: { setStudentData: React.Dispatch<React.SetStateAction<StudentPaymentData>> }) => {
  const [showSearchSection, setShowSearchSection] = useState(true);
  const [searchId, setSearchId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { userType, instituteId } = useMainContainerProvider();
  const { fetchWithAuth } = useFetchWithAuth();

  const handleClear = () => {
    setSearchId('');
  };
  const handleSearch = async () => {
    if (!searchId) return;
    setIsLoading(true);
    try {
      const url = `student/?userType=${userType}&instituteId=${instituteId}&admissionId=${searchId}`;
      const { error, data } = await fetchWithAuth(url);
      if (error) {
        errorToast(error);
        return;
      }
      if (!data || !Array.isArray(data) || data.length === 0) {
        errorToast('No student found with this admission number.');
        return;
      }
      setStudentData(paymentDataForStudent);
      setShowSearchSection(false);
    } catch (err) {
      errorToast('Something went wrong while fetching student data.');
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <View UNSAFE_className={styles.card} marginTop={'size-100'}>
      <Flex justifyContent={'space-between'} width={'100%'}>
        <Heading margin={0} level={4}>
          Search Student
        </Heading>
        <ActionButton isQuiet onPress={() => setShowSearchSection(!showSearchSection)}>
          {showSearchSection ? <ArrowDropUp /> : <ArrowDropDown fontSize="small" />}
        </ActionButton>
      </Flex>
      {showSearchSection && (
        <Flex direction={'row'} justifyContent={'space-between'} marginTop={'size-200'}>
          <TextField
            width={'size-6000'}
            label="Admission Id"
            value={searchId}
            onChange={(value) => {
              const numericValue = value.replace(/\D/g, '').slice(0, 12);
              setSearchId(numericValue);
            }}
          />
          <Flex justifyContent={'end'} gap={'size-100'} marginTop={'size-300'}>
            <Button width={'size-2000'} variant="primary" isDisabled={isLoading || !searchId} onPress={handleClear}>
              Clear
            </Button>
            <Button width={'size-2000'} variant="cta" onPress={handleSearch} isDisabled={isLoading || !searchId}>
              <View marginEnd={'size-100'}>{isLoading && <Loader size={20} />}</View>
              Search
            </Button>
          </Flex>
        </Flex>
      )}
    </View>
  );
};

export default SearchStudent;
